import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeepDive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconDeepDive"><Path d="M14.3944 19.25C14.3944 11.9733 23.4916 13.4655 21.0991 4C17.9144 7.68103 14.8732 6 12.0004 8.5C9.12756 6 6.08545 7.68103 2.90074 4C0.508731 14.5172 9.60634 11.9733 9.60634 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M3 20.25C9.28654 17.25 13.7917 22.5 21 18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconDeepDive;
